import React, { useEffect, useState } from 'react';
import { defineMessages, injectIntl, IntlShape } from 'react-intl';
import { List, Spin } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';

import Connector, { PropsFromRedux } from './Connector';
import {
  FacilityMappingStrategyState,
  // FacilityType,
} from 'src/routes/Customers/modules/types';
import Box from 'src/components/Box';
import ActionButtons from './components/ActionButtons';
import {
  FacilityLabel,
  FacilityMappingWrap,
  FacilitySearchBox,
  FacilityTenantFieldsRow,
} from './style';

type Props = PropsFromRedux & { intl: IntlShape };

const FacilitiesFieldMapping = ({
  intl,
  getCustomerTenants,
  getFacilities,
  customerTenantsList,
  mtmTenantsList,
  facilitiesList,
  facilityInitialDict,
  isLoadingCustomerTenants,
  isLoadingFacilities,
  getTenants,
}: Props) => {
  const [mapFacilitiesForm, setMapFacilitiesForm] =
    useState<FacilityMappingStrategyState>({});
  // const [searchResults, setSearchResults] = useState<FacilityType[] | null>(
  //   null,
  // );

  useEffect(() => {
    getCustomerTenants();
    getFacilities();
    getTenants();
  }, [getCustomerTenants, getFacilities, getTenants]);

  useEffect(() => {
    setMapFacilitiesForm(facilityInitialDict);
  }, [facilityInitialDict]);

  const facilitiesListData = facilitiesList.map(facility => {
    return (
      <FacilityTenantFieldsRow key={facility.id}>
        <FacilityLabel>{facility.facilityName}</FacilityLabel>
        <ArrowRightOutlined />
        <ActionButtons
          id={facility.id}
          mappingForm={mapFacilitiesForm}
          setMapFacilitiesForm={setMapFacilitiesForm}
          customerTenantsList={customerTenantsList}
          mtmTenantsList={mtmTenantsList}
        />
      </FacilityTenantFieldsRow>
    );
  });

  // const onSearch = (value: string) => {
  //   const searchValue = value.toLowerCase();

  //   const facilitySearchResults = facilitiesList.filter(facility => {
  //     const facilityNameSmall = facility.facilityName.toLowerCase();
  //     return facilityNameSmall.includes(searchValue);
  //   });

  //   setSearchResults(facilitySearchResults);
  // };

  if (isLoadingCustomerTenants || isLoadingFacilities) {
    return (
      <Box centered>
        <Spin spinning size="large" />
      </Box>
    );
  }

  return (
    <FacilityMappingWrap>
      <FacilitySearchBox
        placeholder={intl.formatMessage(messages.searchFacility)}
        // onSearch={onSearch}
      />
      <List
        size="large"
        bordered
        dataSource={facilitiesListData}
        renderItem={item => <List.Item>{item}</List.Item>}
      />
    </FacilityMappingWrap>
  );
};

const messages = defineMessages({
  searchFacility: {
    defaultMessage: 'Search facility',
  },
});

export default Connector(injectIntl(FacilitiesFieldMapping));
